import { createQueryKeys } from '@lukemorales/query-key-factory';

export const discoveryKeys = createQueryKeys('discovery', {
  suggestedUsers: 'suggestedUsers',
  activeConnections: 'activeConnections',
});
